import { FlexBox } from 'component/customize_style_component/styled_box';
import React, { useState } from 'react';
import loadingAnimation from '../../assets/img/loading-animations.gif';
import { useStyles } from './style';
import { useSelector } from 'react-redux';
import { RootState, useAppDispatch } from 'redux/store';
import themes from 'styles/themes';
import { Text } from 'component/customize_style_component/styled_title';
import { useLocation } from 'react-router-dom';
import { PATH } from 'routes/constant';
import { globalActions } from 'redux/global/global.slice';

function GlobalLoadingSpinner(props) {
    const spinnerLoading = useSelector((state: RootState) => state.global.spinnerLoading);
    const loadingHome = useSelector((state: RootState) => state.global.loadingHome);
    const [displayLoading, setDisplayLoading] = useState(false);
    const dispatch = useAppDispatch();

    React.useEffect(() => {
        if (spinnerLoading.length && !displayLoading) {
            setDisplayLoading(true);
        } else if (!spinnerLoading.length && displayLoading) {
            setDisplayLoading(false);
            if (loadingHome) {
                dispatch(globalActions.setLoadingHome(false));
            }
        } else if (spinnerLoading.length) {
            setDisplayLoading(true);
        }
        // eslint-disable-next-line
    }, [spinnerLoading, displayLoading]);

    const classes = useStyles();
    return <LoaderMemo classes={classes} displayLoading={displayLoading} />;
}

const Loader = (props) => {
    const { classes, displayLoading } = props;
    const loadingHome = useSelector((state: RootState) => state.global.loadingHome);
    const location = useLocation();

    return (
        <div
            className={classes.loadingBg}
            style={{ backgroundColor: themes.palette.common.white, display: displayLoading ? '' : 'none' }}
        >
            <FlexBox flexdirection="column" justifycontent="center" alignitems="center" style={{ height: '100%' }}>
                <img src={loadingAnimation} alt="" style={{ width: 300, height: 300 }} />
                {loadingHome && location.pathname === PATH.STYLE_ASSISTANT && (
                    <Text size="18px" font="Fraunces_120pt_SuperSoft_Wonky-Regular">
                        Personalizing your Taffi account…
                    </Text>
                )}
            </FlexBox>
        </div>
    );
};

const LoaderMemo = React.memo(Loader);

export default GlobalLoadingSpinner;
